import { http } from './config';

const USERS_PATH = 'users';

export default {
  login: (email, password) =>
    http.post(`${USERS_PATH}/login`, {
      email,
      password
    }),

  listar: object => {
    let params = `page=${object.page ? object.page : 1}`;

    if (object.nome) {
      params += `&nome=${object.nome}`;
    }

    return http.get(`${USERS_PATH}?${params}`);
  },

  salvar: usuario => http.post(USERS_PATH, usuario),

  atualizar: usuario => http.post(`${USERS_PATH}/${usuario._id}`, usuario),

  atualizarSenha: ({ senhaAtual, novaSenha, userId }) =>
    http.post(`${USERS_PATH}/${userId}/updatePassword`, {
      oldPassword: senhaAtual,
      newPassword: novaSenha
    }),

  resetarSenha: email => http.post(`${USERS_PATH}/resetPassword`, { email }),

  solicitarAcesso: email => http.post(`${USERS_PATH}/requestAccess`, { email }),

  deletar: usuario => http.delete(`${USERS_PATH}/${usuario._id}`),

  listarColaboradores: () => http.get(`${USERS_PATH}/colaboradores`),

  listarAdministradores: () => http.get(`${USERS_PATH}/administradores`)
};
